var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#606A8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2016 38.1844C56.6016 38.9927 56.6016 41.0135 55.2016 41.8218L32.5604 54.8936C31.1604 55.7019 29.4104 54.6916 29.4104 53.075L29.4104 26.9312C29.4104 25.3146 31.1604 24.3043 32.5604 25.1126L55.2016 38.1844Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0863a4d35e89e72afe84c58c554984df.svg";
export { ForwardRef as ReactComponent };